import { type LayoutProps, type SiderProps, Layout as AntdLayout } from 'antd';

export function Layout(props: LayoutProps) {
  return <AntdLayout {...props} />;
}

export function Header(props: LayoutProps) {
  return <AntdLayout.Header {...props} />;
}

export function Footer(props: LayoutProps) {
  return <AntdLayout.Footer {...props} />;
}

export function Content(props: LayoutProps) {
  return <AntdLayout.Content {...props} />;
}

export function Sider(props: SiderProps) {
  return <AntdLayout.Sider {...props} />;
}

// components added to Layout to reflect how antd behaves
Layout.Header = Header;
Layout.Footer = Footer;
Layout.Content = Content;
Layout.Sider = Sider;
